import { GlobalJackpotConfigurationSectionProps } from "./../../configurations/components/ConfigurationsPage/NewConfigurationPage/GlobalJackpotConfigurationSection/GlobalJackpotConfigurationSection.component";
import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* loadJson(action) {
    try {
        const loadResponse = yield call(() =>
            gamesAPI.loadJson(action.payload.json)
        );

        yield put({
            type: GamesActionTypes.LOAD_JSON_SUCCESS,
            payload: loadResponse.data
        });
    } catch (e) {
        let error =
            "Uploaded JSON has a format problem. Please fix it and try again.";
        if (
            e.response.data &&
            (e.response.data.code == 10930 || e.response.data.code == 10931)
        ) {
            error = e.response.data.details;
        }
        API.handleError(e.response, "Error loading json file.");

        yield put({
            type: GamesActionTypes.LOAD_JSON_FAIL,
            payload: {
                error: error
            },
            message: e.message
        });
    }
}

export function* loadJsonWatcher() {
    yield takeLatest(GamesActionTypes.LOAD_JSON, loadJson);
}

function* createAlias(action) {
    try {
        yield call(() => gamesAPI.createAlias(action.payload.alias));

        yield put({
            type: GamesActionTypes.CREATE_ALIAS_SUCCESS
        });

        yield put({
            type: GamesActionTypes.LOAD_JSON,
            payload: {
                json: action.payload.json
            }
        });
    } catch (e) {
        API.handleError(
            e.response,
            "Error merging games. Please validate and try again."
        );

        yield put({
            type: GamesActionTypes.CREATE_ALIAS
        });
    }
}

export function* createAliasWatcher() {
    yield takeLatest(GamesActionTypes.CREATE_ALIAS, createAlias);
}
